import React from "react";
import { isHtml, sanitizeHtml } from "../services/richText";

interface RichTextContentProps {
  value?: string | null;
  className?: string;
}

// Renders formatted descriptions safely; older plain-text descriptions keep their line breaks
export function RichTextContent({ value, className = "" }: RichTextContentProps) {
  if (!value) return null;
  if (!isHtml(value)) {
    return <div className={`whitespace-pre-line ${className}`}>{value}</div>;
  }
  return <div className={`rich-text ${className}`} dangerouslySetInnerHTML={{ __html: sanitizeHtml(value) }} />;
}
